import { Avatar } from "@mantine/core";

export default function UserAvatar({ profile }) {
  var name = () => {
    if (!profile) return "Unknown User";

    let name = profile.firstName ?? "";
    if (name && profile.lastName) name += " ";
    if (profile.lastName) name += profile.lastName;
    if (!name) return "Unknown User";
    return name;
  };

  const imageUrl = profile?.profileImageUrl
    ? `https://app.promptshuttle.com/cdn-cgi/image/width=76,quality=75/${profile.profileImageUrl}`
    : null;

  return (
    <Avatar
      src={imageUrl}
      name={name()}
      color="initials"
      size="md"
      radius="xl"
    ></Avatar>
  );
}
